import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  FormGroup,
  Label,
  CustomInput,
} from "reactstrap";
import style from "./styles.module.scss";
import LaddaButton, { SLIDE_LEFT } from "react-ladda";
import { FormSelect } from "../Controls";

const initialFields = {
  SettlementCurrencyId: -1,
  SettlementCurrencyISO: "",
  SettlementCurrencyDescription: "",
  SettlementCurrencyIsDefault: false,
};

const ModalCurrency = ({ open, toggle, currency, currencies, onConfirm }) => {
  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({});

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (currency) {
      setFields(currency);
    } else {
      setFields(initialFields);
    }
  }, [currency]);

  const onChange = (name, value) => {
    setFields({ ...fields, [name]: value });
    setErrors({ ...errors, [name]: undefined });
  };

  const handleSave = async () => {
    const errors = validate(fields);

    if (Object.keys(errors).length == 0) {
      setLoading(true);
      const { currencyISO, currencyDescription } = currencies.find(
        (e) => e.currencyId == fields.SettlementCurrencyId
      );
      let result = await onConfirm({
        ...fields,
        SettlementCurrencyISO: currencyISO,
        SettlementCurrencyDescription: currencyDescription,
      });
      setLoading(false);

      if (result == 200) {
        toggle();
      }
    }
  };

  return (
    <Modal isOpen={open} toggle={toggle} className={style.modal}>
      <ModalHeader toggle={toggle}>{currency ? "Edit currency" : "Add currency"}</ModalHeader>
      <ModalBody>
        {currencies ? (
          <FormSelect
            name="SettlementCurrencyId"
            label="Settlement currency"
            selectItems={currencies}
            getSelectItemId={(i) => i.currencyId}
            getSelectItemName={(i) => `${i.currencyISO} - ${i.currencyDescription}`}
            value={fields.SettlementCurrencyId}
            disabled={currency ? true : false}
            onChange={onChange}
          />
        ) : (
          <Spinner size="sm" />
        )}
        <FormGroup>
          <CustomInput
            id="SettlementCurrencyIsDefault"
            type="checkbox"
            label="Is Default"
            checked={fields.SettlementCurrencyIsDefault}
            onChange={(e) => onChange("SettlementCurrencyIsDefault", e.target.checked)}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle}>
          Cancel
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary pl-3 pr-3"
          loading={loading}
          disabled={false}
          onClick={() => handleSave()}
          data-style={SLIDE_LEFT}
        >
          <i className="fa fa-floppy-o mr-1" aria-hidden="true"></i>
          Save
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

function validate(fields) {
  Object.entries(fields).forEach(([name, value]) => {});

  return {};
}

export default ModalCurrency;
